import { type ReactElement } from "react";

import { Icon } from "@icg360/design-system";

import CalculatorIcon from "images/write-out-icons/calculator-icon.svg?react";
import LeafIcon from "images/write-out-icons/leaf-icon.svg?react";
import PropertyIcon from "images/write-out-icons/location-pin-icon.svg?react";
import LossHistoryIcon from "images/write-out-icons/loss-history-icon.svg?react";
import OccupancyIcon from "images/write-out-icons/occupancy-icon.svg?react";
import UndefinedIcon from "images/write-out-icons/question-mark-icon.svg?react";
import RoofIcon from "images/write-out-icons/roof-icon.svg?react";
import ShieldIcon from "images/write-out-icons/shield-icon.svg?react";
import StructureIcon from "images/write-out-icons/structure-icon.svg?react";

export const WriteOutIcon = ({ category }: { category?: string | null }) => {
  const capsCategory = category?.toUpperCase();
  const CATEGORY_ICON_MAP: Record<string, ReactElement> = {
    ANIMALS: <ShieldIcon />,
    "ATTRACTIVE NUISANCE": <ShieldIcon />,
    EXTERIOR: <Icon name="Home" />,
    LIABILITY: <ShieldIcon />,
    LOSS: <LossHistoryIcon />,
    OCCUPANCY: <OccupancyIcon />,
    OTHER: <Icon name="Overflow" />,
    "PENDING DOCS": <Icon name="Clock" />,
    PROPERTY: <PropertyIcon />,
    "RATING VARIABLE CHANGE": <CalculatorIcon />,
    ROOF: <RoofIcon />,
    "RVC OR ITV": <CalculatorIcon />,
    STRUCTURE: <StructureIcon />,
    TREES: <LeafIcon />,
    "UNDISCLOSED FEATURES": <Icon name="ViewOff" />,
  };

  if (!capsCategory || !CATEGORY_ICON_MAP[capsCategory]) {
    return <UndefinedIcon />;
  } else {
    return CATEGORY_ICON_MAP[capsCategory];
  }
};
